import { render } from "./TableHistory.vue?vue&type=template&id=6bb4f4dd"
import script from "./TableHistory.vue?vue&type=script&lang=js"
export * from "./TableHistory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/YuyiiChiMila/Company/GAME-MAKRO/outlier-p002/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__